import { PRICELIST_LIST, PRICELIST_CUSTOMER_FILTER, PRICELIST_CURRENT } from '../../mutationTypes'

const mutations = {
  [PRICELIST_CUSTOMER_FILTER](state, action){
    state.filterCustomerId = action.customerId
  },
  [PRICELIST_CURRENT](state, action){
    state.current = action.priceList
  },
  [PRICELIST_LIST](state, action){
    state.items = action.items
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./client/store/modules/pricelist/priceListMutations.js